import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PropertyCard from "./PropertyCard";
import { ArrowUpRight } from "lucide-react";

export default function FeaturedManaged() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/properties", { params: { managed: true, limit: 6 } })
      .then((r) => setItems(r.data.slice(0, 6)))
      .catch(() => {});
  }, []);

  return (
    <section id="managed-properties" className="bg-[#FAFAF8] py-20 md:py-24" data-testid="featured-managed-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="kicker mb-3">Appy Managed Collection</div>
            <h2 className="font-sora text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0E2E24] leading-tight">
              Our signature managed stays.
            </h2>
            <p className="mt-4 text-[#5B6B63] text-base md:text-lg leading-relaxed">
              Premium Appy-managed properties built for seamless celebrations — staff, decor, food and music handled.
            </p>
          </div>
          <Link to="/stays?managed=true" className="font-sora text-sm font-medium text-[#1F5A43] hover:text-[#0E2E24] flex items-center gap-1.5" data-testid="featured-see-managed">
            See all 10 managed stays <ArrowUpRight size={15} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => <PropertyCard key={p.id} p={p} />)}
        </div>
      </div>
    </section>
  );
}
